<form id="informations-client-form" class="px-4" [formGroup]="garageForm">
  <div class="d-flex justify-content-between mb-5">
    <div class="col-4">
      <p-input
        [formControl]="garageForm.controls.propertyType"
        id="propertyType"
        name="propertyType"
        label="Type de bien"
        [disabled]="true"
      ></p-input>
    </div>

    <div class="col-4">
      <p-input
        [formControl]="garageForm.controls.constructionYear"
        id="constructionYear"
        name="constructionYear"
        label="Année de construction"
        [maxLengthNumber]="4"
        (input)="onConstructionYearChanged($event)"
        type="number"
        errorMessage="L'année de construction doit être un nombre à 4 chiffres."
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-select
        id="garageType"
        [items]="garageTypeItems"
        [selectedItem]="garageTypeItem"
        label="Type de garage"
        (selected)="onGarageTypeSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="garageForm.controls.numberOfParkingSlots"
        id="numberOfParkingSlots"
        name="numberOfParkingSlots"
        label="Nb d'emplacements"
        placeholder="Ex : 10"
        type="number"
        (input)="onNumberOfParkingSlotsChanged($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="garageForm.controls.floor"
        type="number"
        id="floor"
        name="floor"
        label="Etage"
        placeholder="Ex : 2"
        (input)="onFloorChanged($event)"
      ></p-input>
    </div>
  </div>
</form>
